<template>
  <div v-loading="tableLoading">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>支付配置</el-breadcrumb-item>
      <el-link type="primary" style="float:right" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </el-breadcrumb>
    <div>
       <div class="flex-spc-x" style="width:100%;margin-top:30px;">
            <el-table
                             :data="ListPaySetting"
                             tooltip-effect="dark"
                             border
                             stripe
                             style="width: 100%">
                            <el-table-column type="index" label="序号"  width="80" align="center"  ></el-table-column>
                             <el-table-column label="名称" width="300" prop="name"></el-table-column>
                            <el-table-column  label="功能介绍"  >
                                 <template slot-scope="scope">
                                  <span> {{scope.row.info}}</span>
                            </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" width="200">
                            <template slot-scope="scope">
                                <el-switch 
                                     v-model="scope.row.Ison"
                                     on-color="#00A854"
                                    on-text="启动"
                                     on-value="1"
                                     off-color="#F04134"
                                      off-text="禁止"
                                     off-value="0"
                                 @change="changeSwitch(scope.row)">
                                    </el-switch>
 
                            </template>
                        </el-table-column>
                        </el-table>
        
    </div>
    </div>
    </div> 
</template>
<script>
import CropperImage from "../../components/CropperImage";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
 
    DianList:[],
    SelectStoresID:localStorage.getItem("StoresID"),
    tableLoading:false,
    overtype:0,
    ListPaySetting:[],
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      }
    
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
         this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      tosetting(){
         this.$router.push({ path: '/setting/setting'})
      } ,
      getList(){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
    
      }
     
      
        var that = this
      this.ajax('getListPaySetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.ListPaySetting = res.data
            for (let i = 0; i < res.data.length; i++) {
                        
                        if(res.data[i].Ison =='1'){
                        that.ListPaySetting[i].Ison = true;

                        }else{
                        that.ListPaySetting[i].Ison = false;

                        }
                    }
          } 

      })
  
  
    },changeSwitch(val){
                 this.overtype = val.sType;
                 let ison = 0;
               if(val.Ison){
                   ison =1;
               }else{

                   ison =0;
               }

               this.editPaySettingIson(val.ID , ison);
            }, editPaySettingIson(SttingID,Ison){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SttingID:SttingID,
          Ison:Ison
         }
     
      
        var that = this
         this.ajax('editPaySettingIson.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

            }
   
  }
}
</script>
 


// WEBPACK FOOTER //
// src/views/setting/PaySettingInfo.vue